// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1hgs5","messages":"Chat_messages__33Yzx","dateDivider":"Chat_dateDivider__3D0eg"};